import { includes } from "lodash";
import { sanitizeMessagesForPersist } from "@Utils";
import {
	LOGIN,
	CHOOSE_COMPANY,
	UPDATE_COMPANY,
	CHANGE_STATE,
	TOGGLE_VIEW_AUTOGESTION,
	UPDATE_USER,
	SET_CURRENT_CHAT,
	TOGGLE_SIDEBAR,
} from "@Actions/types";

const persist = (store) => {
	return (next) => {
		return async (action) => {
			const result = next(action);
			const actions = [
				LOGIN,
				CHOOSE_COMPANY,
				UPDATE_COMPANY,
				CHANGE_STATE,
				TOGGLE_VIEW_AUTOGESTION,
				UPDATE_USER,
				SET_CURRENT_CHAT,
				TOGGLE_SIDEBAR,
			];

			if (includes(actions, action.type)) {
				const state = store.getState();
				const persistedState = {
					...state,
					chats: {
						...state.chats,
						messages: sanitizeMessagesForPersist(state.chats.messages),
					},
					history: {
						...state.history,
						messages: sanitizeMessagesForPersist(state.history.messages),
					},
				};
				sessionStorage.setItem("store", JSON.stringify(persistedState));
			}

			return result;
		};
	};
};

export default persist;
